/**
 * @param {string} date ISO 8601 format (e.g., 2023-02-01T00:00:00.000Z)
 * @returns {string} Short formatted date(e.g., 2/3/2023)
 */
export default function formatShortDate(date) {
  return new Date(Date.parse(date)).toLocaleDateString('en-US', { timeZone: 'UTC' });
}
